import React from 'react'
import premises from '../images/premises_screen.png'
import buyer from '../images/buyer_screen.png'
import summary from '../images/summary_screen.png'
import payment from '../images/payment_screen.png'
import success from '../images/success_screen.png'
import email from '../images/email_screen.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faFileArrowDown, faLink } from '@fortawesome/free-solid-svg-icons'

const premisesSteps = [
	{
		description: 'All fields are required, except Address Line 2, which is optional.',
	},
	{
		description:
			'The State field is disabled. (The wizard is designed for Tasmanian properties only).',
	},
	{
		description:
			'If you require a Residential Tenancy Agreement for a property in another state, please contact Forms Live support.',
	},
]

const buyerSteps = [
	{
		description: 'All fields are required, except Address Line 2.',
	},
	{
		description: 'The State field is enabled in this section.',
	},
]

const summarySteps = [
	{
		description: 'If you need to make changes, click Edit to return to the relevant section.',
	},
	{
		description: 'Once confirmed, continue to payment.',
	},
]

const paymentSteps = [
	{
		description:
			'The total amount payable is displayed in the top-right of the card details section.',
	},
	{
		description: 'Accepted card types are shown next to the card input fields.',
	},
	{
		description:
			'A reCAPTCHA is located in the bottom-left corner of the form. You must tick the checkbox to proceed with payment.',
	},
]

const completeSteps = [
	{
		name: 'Download:',
		description: 'Residential Tenancy Agreement',
		icon: faFileArrowDown,
	},
	{
		name: 'Download:',
		description: 'Condition Report',
		icon: faFileArrowDown,
	},
	{
		name: 'Link:',
		description: 'Rental Guide',
		icon: faLink,
	},
	{
		name: 'Link:',
		description: 'How to lodge or pay a bond',
		icon: faLink,
	},
]

const emailSteps = [
	{
		description: 'This email includes three download links for your purchased documents. ',
		icon: faAngleRight,
	},
]

export default function Guide() {
	return (
		<div className='bg-white'>
			{/* Premises Details */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-lg font-semibold text-blue-600'>Step 1</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Premises Details
							</p>
							<p className='mt-6 text-2xl text-gray-600'>
								Enter the details of the property being leased.
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{premisesSteps.map((premise) => (
									<div key={premise.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon icon={faAngleRight} className='fill-current text-blue-600' />
										</dt>{' '}
										<dd className='inline'>{premise.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={premises} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>

			{/* Purchaser Details */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-xl font-semibold text-blue-600'>Step 2</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Purchaser Details
							</p>
							<p className='mt-6 text-xl text-gray-600'>
								Enter the details of the person purchasing the Residential Tenancy Agreement.
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{buyerSteps.map((buyer) => (
									<div key={buyer.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon icon={faAngleRight} className='fill-current text-blue-600' />
										</dt>{' '}
										<dd className='inline'>{buyer.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={buyer} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>

			{/* Summary Screen */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-xl font-semibold text-blue-600'>Step 3</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Order Summary
							</p>
							<p className='mt-6 text-xl text-gray-600'>
								Review your selections before proceeding to payment.
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{summarySteps.map((summary) => (
									<div key={summary.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon icon={faAngleRight} className='fill-current text-blue-600' />
										</dt>{' '}
										<dd className='inline'>{summary.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={summary} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>

			{/* Payment Screen */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-xl font-semibold text-blue-600'>Step 4</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Payment Details
							</p>
							<p className='mt-6 text-xl text-gray-600'>
								Enter your payment details to complete the purchase.
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{paymentSteps.map((payment) => (
									<div key={payment.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon icon={faAngleRight} className='fill-current text-blue-600' />
										</dt>{' '}
										<dd className='inline'>{payment.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={payment} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>

			{/* Complete Order */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-xl font-semibold text-blue-600'>Step 5</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Complete Order
							</p>
							<p className='mt-6 text-xl text-gray-600'>
								Once payment is successfully processed, you will be redirected to a confirmation
								screen. From here, you can access the following:
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{completeSteps.map((complete) => (
									<div key={complete.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon
												icon={complete.icon}
												className='fill-current text-blue-600'
											/>
										</dt>{' '}
										<dt className='inline font-semibold text-gray-900'>{complete.name}</dt>{' '}
										<dd className='inline'>{complete.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={success} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>

			{/* Email Confirmation */}
			<div className='relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
				<div className='mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none'>
					<div className='px-6 lg:px-0 lg:pt-4 lg:pr-4'>
						<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
							<h2 className='text-xl font-semibold text-blue-600'>Step 6</h2>
							<p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-5xl'>
								Email Confirmation
							</p>
							<p className='mt-6 text-xl text-gray-600'>
								A confirmation email will be sent to the email address provided.
							</p>
							<dl className='mt-10 max-w-xl space-y-8 text-xl font-light text-gray-600 lg:max-w-none'>
								{emailSteps.map((email) => (
									<div key={email.name} className='relative'>
										<dt className='inline font-semibold text-gray-900'>
											<FontAwesomeIcon
												icon={email.icon}
												className='fill-current text-blue-600'
											/>
										</dt>{' '}
										<dd className='inline'>{email.description}</dd>
									</div>
								))}
							</dl>
						</div>
					</div>
					<div className='mt-8 lg:grid lg:grid-cols-1 lg:gap-8'>
						<div className='relative lg:row-start-1 lg:col-start-2'>
							<div className='relative text-base mx-auto max-w-prose lg:max-w-none'>
								<figure>
									<img src={email} alt='Premises Details form' />
								</figure>
							</div>
						</div>
					</div>
				</div>
				<hr className='mt-24 border-t border-gray-200' />
			</div>
		</div>
	)
}
